<script lang="ts">
	import { getModalContext } from './Modal.svelte';
	export let title: string;
</script>

<div class="text-2xl font-medium">
	{title}
</div>
